function commonPrefixAtWord(a: string, b: string): string {
  let i = 0;
  while (i < a.length && i < b.length && a[i] === b[i]) i++;
  const p = a.slice(0, i);
  const lastSpace = p.lastIndexOf(" ");
  return lastSpace > 0 ? p.slice(0, lastSpace + 1) : "";
}

function commonSuffixAtWord(a: string, b: string): string {
  let i = 0;
  while (i < a.length && i < b.length && a[a.length - 1 - i] === b[b.length - 1 - i]) i++;
  const s = a.slice(a.length - i);
  const firstSpace = s.indexOf(" ");
  return firstSpace > 0 ? s.slice(firstSpace) : "";
}

// For each name, find the peer it shares the longest prefix with, and strip
// that shared prefix (and matching suffix) to produce the distinguishing part.
// This handles groups containing both very-similar products and unrelated ones.
export function extractUniqueBadges(names: string[]): Map<string, string> {
  const badges = new Map<string, string>();
  if (names.length < 2) return badges;

  for (const name of names) {
    let bestPrefix = "";
    let bestSuffix = "";
    for (const other of names) {
      if (other === name) continue;
      const p = commonPrefixAtWord(name, other);
      const s = commonSuffixAtWord(name, other);
      if (p.length > bestPrefix.length) bestPrefix = p;
      if (s.length > bestSuffix.length) bestSuffix = s;
    }
    if (bestPrefix.length < name.length * 0.3) continue;
    let unique = name.slice(bestPrefix.length);
    if (bestSuffix.length > 0 && unique.length > bestSuffix.length) {
      unique = unique.slice(0, unique.length - bestSuffix.length);
    }
    unique = unique.trim();
    if (!unique || unique === name) continue;

    // Keep the last word of the shared prefix as context so the badge is readable.
    const trimmedPrefix = bestPrefix.replace(/\s+$/, "");
    const lastSpaceIdx = trimmedPrefix.lastIndexOf(" ");
    const contextWord =
      lastSpaceIdx >= 0 ? trimmedPrefix.slice(lastSpaceIdx + 1) : trimmedPrefix;
    badges.set(name, contextWord ? `…${contextWord} ${unique}` : unique);
  }

  return badges;
}
